import React from 'react';
import { Routes, Route } from "react-router-dom";
import LoginPage from "./components/pages/LoginPage";
import UserHomePage from "./components/pages/UserHomePage";
import UserCollectionPage from "./components/pages/UserCollectionPage";
import UserMaterialPage from "./components/pages/UserMaterialPage";
import UserSiteMapPage from "./components/pages/UserSiteMapPage";
import UserMyAccountPage from "./components/pages/UserMyAccountPage";
import UserInfoPage from "./components/pages/UserInfoPage";
import UserPassPage from "./components/pages/UserPassPage";
import UserMailPage from "./components/pages/UserMailPage";
import UserContactPage from "./components/pages/UserContactPage";
import UserTermsPage from "./components/pages/UserTermsPage";
import UserChat from './components/organisms/UserChat'; 
import AdminHomePage from "./components/pages/AdminHomePage";
import AdminPagePage from './components/pages/AdminPagePage';
import AdminContentPage from './components/pages/AdminContentPage';
import AdminChatCompanyPage from './components/pages/AdminChatCompanyPage';
import AdminChatUserPage from './components/pages/AdminChatUserPage';
import AdminChatPage from './components/pages/AdminChatPage';
import AdminUserCompanyPage from './components/pages/AdminUserCompanyPage';
import AdminUserListPage from './components/pages/AdminUserListPage';
import AdminUserPage from './components/pages/AdminUserPage';
import EduTopPage from './components/pages/EduTopPage';
import EduQuestionPage from './components/pages/EduQuestionPage';
import './App.css';
import UserTestPage from './components/pages/UserTestPage';
import EntryHomePage from './components/pages/EntryHomePage';
import EntryMaterialPage from './components/pages/EntryMaterialPage';
import GuestRegisterPage from './components/pages/GuestRegisterPage';
import UserProblemsPage from './components/pages/UserProblemsPage';
import GuestTestPage from "./components/pages/GuestTestPage"; // ゲスト向けのテストページ
import PreventBackButton from "./components/PreventBackButton";
import TermsOfService from './components/pages/TermsOfService';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import VideoSample from './components/pages/VideoSample';


function AuthRoute({element, auth} : {element: JSX.Element, auth: number}) {
  if(Number(sessionStorage.getItem('userType')) >= auth) {
    return element;
  } else {
    document.location = "/login";
    return  <LoginPage />;
  }
}


function App() {
  return (
    <>
      <PreventBackButton />
      <Routes>
        
        <Route path="/login" element={<LoginPage />} />
        <Route path="/term-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/guest/register" element={<GuestRegisterPage />} />
        <Route path="/entry/home" element={<AuthRoute auth={1} element={<EntryHomePage />}/>} />
        <Route path="/entry/material" element={<AuthRoute auth={1} element={<EntryMaterialPage />}/>} />
        <Route path="/entry/material/test" element={<AuthRoute auth={1} element={<GuestTestPage />}/>} />

        <Route path="/home" element={<AuthRoute auth={2} element={<UserHomePage />}/>} />
        <Route path="/collection" element={<AuthRoute auth={2} element={<UserCollectionPage />}/>} />
        <Route path="/material" element={<AuthRoute auth={2} element={<UserMaterialPage />}/>} />
        <Route path="/test" element={<AuthRoute auth={2} element={<UserTestPage />}/>} />
        <Route path="/sitemap" element={<AuthRoute auth={2} element={<UserSiteMapPage />}/>} />
        <Route path="/myAccount" element={<AuthRoute auth={2} element={<UserMyAccountPage />}/>} />
        <Route path="/userInfo" element={<AuthRoute auth={2} element={<UserInfoPage />}/>} />
        <Route path="/userPass" element={<AuthRoute auth={2} element={<UserPassPage />}/>} />
        <Route path="/userMail" element={<AuthRoute auth={2} element={<UserMailPage />}/>} />
        <Route path="/contact" element={<AuthRoute auth={2} element={<UserContactPage />}/>} />
        <Route path="/terms" element={<AuthRoute auth={2} element={<UserTermsPage />}/>} />
        <Route path="/problems" element={<AuthRoute auth={2} element={<UserProblemsPage />}/>} />
        <Route path="/chattest" element={<AuthRoute auth={2} element={<UserChat height={500}/>}/>} /> {/* テスト用 */}
    {/*
          <Route path="/admin/home" element={<AdminHomePage />} />
          <Route path="/admin/page" element={<AdminPagePage />} />
          <Route path="/admin/content" element={<AdminContentPage />} />
          <Route path="/admin/chat-company" element={<AdminChatCompanyPage />} />
          <Route path="/admin/chat-user" element={<AdminChatUserPage />} />
          <Route path="/admin/chat" element={<AdminChatPage />} />
          <Route path="/admin/user-company" element={<AdminUserCompanyPage />} />
          <Route path="/admin/user-list" element={<AdminUserListPage />} />
          <Route path="/admin/user" element={<AdminUserPage />} />

          <Route path="/edu/top" element={<EduTopPage />} />
          <Route path="/edu/question" element={<EduQuestionPage />} />
    */}
          <Route path="/video-sample" element={<VideoSample />} />
          <Route path="*" element={<LoginPage />} />
        </Routes>
    </> 
  );
}

export default App;